import {Component, ViewChild} from '@angular/core';
import { CostPriceComponentService } from '../cost-price-component.service';
import {BehaviorSubject, combineLatest, from, Observable} from "rxjs";
import {FilterModel, getBase64, PRIVILEGES, TableComponent} from "common-shared";
import {Table} from "primeng/table";
import {
  CostPriceComponentPriceListModel,
  ItemQuery,
  ItemsQuery,
  StateService
} from "web-shared";
import {map, takeUntil} from "rxjs/operators";
import { Router } from '@angular/router';
import {saveAs} from 'file-saver';
import {ResourcesQuery} from "../../resources/resource.store";
import {ResourceQuery} from "../../resources/models/resource.query";

@Component({
  selector: 'app-cost-price-component-list',
  templateUrl: './cost-price-component-list.component.html',
  styles: [
  ]
})
export class CostPriceComponentListComponent extends TableComponent {
  costComponents$: Observable<CostPriceComponentPriceListModel[]>;
  filter$: BehaviorSubject<FilterModel<CostPriceComponentPriceListModel>>
  @ViewChild(Table) table: Table;
  protected readonly PRIVILEGES = PRIVILEGES;
  mode: 'Resource' | 'Item';

  constructor(private costPriceComponentService: CostPriceComponentService, private itemsQuery: ItemsQuery, private resourcesQuery: ResourcesQuery, private state: StateService, private router: Router) {
    super();
  }

  ngOnInit() {
    this.mode = this.router.url.includes('resource') ? 'Resource' : 'Item';
    this.restoreFilterState();
    this.configureData();
  }

  private configureData() {
    const costComponents$ = this.mode === 'Item'
        ? this.costPriceComponentService.getAllItemCostPriceComponentPrices()
        : this.costPriceComponentService.getAllResourceCostPriceComponentPrices();
    const entities$ = this.mode === 'Item' ? this.itemsQuery.getAll$ : this.resourcesQuery.getAll$;
    this.costComponents$ = combineLatest([costComponents$, this.costPriceComponentService.getAll$, entities$]).pipe(map(([costComponents, cpcs, entities]) => {
      costComponents = costComponents.map(component => {
        component.Component = cpcs.find(cpc => cpc.Id === component.CostPriceComponentId)?.DisplayName;
        if (this.mode === 'Item') {
          component.Item = (entities as any as ItemQuery[]).find(item => item.Id === component.ItemId)?.DisplayName;
        } else {
          component.Resource = (entities as any as ResourceQuery[]).find(resource => resource.Id === component.ResourceId)?.DisplayName;
        }
        return component;
      });
      return costComponents;
    }));
  }

  ngAfterViewInit() {
    this.configureFilter();
  }

  private restoreFilterState() {
    const filterState = this.state.getFilterState<CostPriceComponentPriceListModel>() ?? new FilterModel<CostPriceComponentPriceListModel>({Data: new CostPriceComponentPriceListModel()});
    this.filter$ = new BehaviorSubject<FilterModel<CostPriceComponentPriceListModel>>(filterState);
  }

  private configureFilter() {
    this.filter$.pipe(takeUntil(this.componentDestroyed), map(filter => {
      this.state.setFilterState(filter);
      this.table?.filterGlobal(filter.Global, 'contains');
    })).subscribe();
  }

  export() {
    const values$ = this.table.filteredValue ? from([this.table.filteredValue]) : this.costComponents$;
    values$.pipe(takeUntil(this.componentDestroyed)).subscribe(values => {
      const ids = values.map(value => value.Id);
      const action = this.mode === 'Item' ? 'ExportItemCostComponentsAsExcel' : 'ExportResourceCostComponentsAsExcel';
      this.costPriceComponentService.exportExcel(ids, action).pipe(takeUntil(this.componentDestroyed)).subscribe(value => {
        saveAs(value.data, value.fileName);
      });
    });
  }

  import(event: Event) {
    getBase64((event.target as HTMLInputElement).files[0]).pipe(takeUntil(this.componentDestroyed)).subscribe(fileData => {
      (event.target as HTMLInputElement).value = null;
      const action = this.mode === 'Item' ? 'ImportItemCostComponentsFromExcel' : 'ImportResourceCostComponentsFromExcel';
      this.costPriceComponentService.importExcel(fileData, action).subscribe(value => {
        if (value.data) {
          this.configureData();
        }
      });
    });
  }
}
